<ng-container *ngIf="!isDetailView">
  <h1 class="break-word" *ngIf="!showMobileFilters || !utilService.isMobile">{{ 'general.api_ticket_tool' | translate }}</h1>
  <div class="flex space-between mobile" *ngIf="showMobileFilters">
    <h2 class="break-word">{{ 'general.api_ticket_tool_filters' | translate }}</h2>
    <div class="align-right">
      <button mat-button class="icon-button" (click)="toggleFilters()">
        <mat-icon class="svg-icon" [svgIcon]="'close'"></mat-icon>
      </button>
    </div>
  </div>
  <app-loader [loading]="isLoading" [overlay]="true"></app-loader>
  <form #searchForm="ngForm" class="filter" [ngClass]="{'no-border': showMobileFilters}" (ngSubmit)="isFormValid && search()" autocomplete="off">
    <div class="flex flex-grow flex-filters mobile" *ngIf="utilService.isMobile && !showMobileFilters">
      <app-datepicker class="max-width" [(dateStart)]="filters.dateStart" [(dateEnd)]="filters.dateEnd"
                      [datePickerConfig]="dateRangeConfigMobile" (dateChanged)="!showMobileFilters && applyMobileDateChange()"></app-datepicker>
      <button type="button" mat-button class="icon-button input-button mobile" (click)="toggleFilters()">
        <mat-icon class="svg-icon" [svgIcon]="'filters'"></mat-icon>
      </button>
    </div>
    <div class="flex flex-filters flex-wrap" [ngClass]="{'desktop' : !showMobileFilters, 'flex-column-mobile' : showMobileFilters}">
      <app-datepicker [(dateStart)]="filters.dateStart" [(dateEnd)]="filters.dateEnd" [datePickerConfig]="dateRangeConfig"></app-datepicker>
      <app-numeric-input [label]="'general.api_reports_ticket_id'" [(value)]="filters.ticketId"></app-numeric-input>
      <app-text-input [label]="'general.api_reports_barcode'" [(value)]="filters.barcode"></app-text-input>
      <app-scroll-load [label]="'general.api_reports_customer_or_email'" [minInput]="2"
                        [(fieldValue)]="filters.customerEmail"
                        [searchService]="customerService" [scrollLoad]="customerScrollLoad" (clearEvent)="filters.customerEmail = ''"
                        [(selectedObjectId)]="filters.customerUuid" (selectedObjectChange)="updateCustomer($event)"></app-scroll-load>
      <div class="flex flex-flat">
        <mat-form-field appearance="outline" class="no-hint prefix-field condensed">
          <mat-label>{{ 'general.api_reports_event_status' | translate }}</mat-label>
          <mat-select [(ngModel)]="eventStatusId" [ngModelOptions]="{standalone: true}">
            <mat-select-trigger>{{displayFilterSelectedOption(eventStatusId, eventStatuses) | translate}}</mat-select-trigger>
            <mat-option [value]="null">&nbsp;-&nbsp;</mat-option>
            <mat-option *ngFor="let status of eventStatuses" [value]="status.id">
              {{status.name | translate}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <app-scroll-load [label]="'general.api_reports_event_name'" [minInput]="3" [withPrefix]="true" [clearOnBlur]="true"
                          [customFilters]="{statusIds: [eventStatusId], eventType: EventType.Bo3}"
                          [searchService]="eventService" [scrollLoad]="eventScrollLoad"
                          [(selectedObjectId)]="filters.eventId"></app-scroll-load>
      </div>
      <app-numeric-input [label]="'general.api_reports_invoice_number'" [(value)]="filters.invoiceNumber" [ignoreMax32]="true"></app-numeric-input>
      <mat-form-field appearance="outline" class="no-hint" *ngIf="salespoints?.length">
        <mat-label>{{ 'general.api_reports_salespoint' | translate }}</mat-label>
        <mat-select [(ngModel)]="filters.salespointId" [ngModelOptions]="{standalone: true}">
          <mat-select-trigger>{{displayFilterSelectedOption(filters.salespointId, salespoints)}}</mat-select-trigger>
          <mat-option>
            <app-select-search [values]="salespoints" [filterBy]="['name']" (filteredValues)="salespointsFiltered.next($event.slice())"></app-select-search>
          </mat-option>
          <mat-option [value]="null">&nbsp;-&nbsp;</mat-option>
          <mat-option *ngFor="let salespoint of salespointsFiltered | async" [value]="salespoint.id">
            {{ salespoint.name | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <div class="flex flex-end desktop">
        <button mat-button type="button" (click)="clearFilters()">
          {{ 'general.api_general_clear' | translate }}
        </button>
        <button mat-flat-button color="primary" type="submit" [disabled]="!isFormValid">
          {{ 'general.api_ticket_tool_search' | translate }}
        </button>
      </div>
      <footer *ngIf="showMobileFilters" class="mobile">
        <mat-dialog-actions>
          <button mat-button type="button" (click)="clearFilters()">
            {{ 'general.api_general_clear' | translate }}
          </button>
          <button type="submit" mat-flat-button color="primary" [disabled]="!isFormValid">
            {{ 'general.api_ticket_tool_search' | translate }}
          </button>
        </mat-dialog-actions>
    </footer>
    </div>
  </form>

  <ng-container *ngIf="(!showMobileFilters || !utilService.isMobile) && !isLoading">
    <h2 class="desktop">{{ 'general.api_search_results' | translate }}</h2>
    <app-info-message *ngIf="!results?.items?.length" [message]="noSearches ? 'general.api_reports_choose_filter' : 'general.api_reports_table_no_results'"
                      [icon]="'alert'" [large]="true"></app-info-message>
  </ng-container>

  <ng-container *ngIf="!isLoading && (!showMobileFilters || !utilService.isMobile)">
    <mat-card appearance="outlined" *ngIf="results?.items?.length">
      <app-pagination [page]="page" [pageSize]="pageSize" [total]="results.total" (pageChange)="search($event)" [onTop]="true"></app-pagination>
      <div class="flex flex-wrap space-between">
        <mat-form-field class="dynamic-width">
          <mat-label>{{ 'general.api_sort_by' | translate }}:</mat-label>
          <mat-select [(ngModel)]="sortOrder" [ngModelOptions]="{standalone: true}" (ngModelChange)="search()">
            <mat-select-trigger>{{ displaySortWith(sortOrder) | translate }}</mat-select-trigger>
            <mat-option *ngFor="let sortByOption of sortByOptions" [value]="sortByOption.order">
              {{sortByOption.title | translate}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <app-link [icon]="'download'" [link]="'general.api_general_csv'" (linkClicked)="downloadCsv()"></app-link>
      </div>
      <app-data-table *ngIf="dataTableConfig" [config]="dataTableConfig" [useResponsive]="true" [data]="results.items"></app-data-table>
      <app-pagination [page]="page" [pageSize]="pageSize" [total]="results.total" (pageChange)="search($event)"></app-pagination>
    </mat-card>
  </ng-container>
</ng-container>

<!-- TABLE TEMPLATES -->
<ng-template #statusTemplate let-item="item">
  {{ ('general.api_ticket_tool_status_' + (item.status | lowercase)) | translate }}
</ng-template>
<ng-template #opTimeTemplate let-item="item">
  {{ item.operation.time | moment: { withTime: true } }}
</ng-template>
<ng-template #eventTemplate let-item="item">
  <span class="bold" *ngIf="!authService.hasSelfServiceEventsAccessPrivilege">{{item.event.title | translateValue}}</span>
  <app-link class="bold" *ngIf="authService.hasSelfServiceEventsAccessPrivilege" [link]="item.event.title | translateValue" (linkClicked)="openEvent(item.event.id)" [wrap]="true"></app-link>
  <br><app-event-info-props [eventProps]="{id: item.event.id, eventPeriod: item.event.eventDate}" [alignRight]="utilService.isMobile"></app-event-info-props>
</ng-template>
<ng-template #ticketTypeTemplate let-item="item">
  {{ item.pricing.typeName | translateValue }}
</ng-template>
<ng-template #priceTemplate let-item="item">
  {{ item.pricing.price | price: true }}
</ng-template>
<ng-template #customerTemplate let-item="item">
  <span class="medium">
    {{ item.customer?.firstName?.length + item.customer?.lastName?.length > 0 ? (item.customer?.firstName + ' ' + item.customer?.lastName) : '-' }}
  </span>
</ng-template>
<ng-template #deliveryEmailTemplate let-item="item">
  <br *ngIf="item.customer?.deliveryEmail">{{ item.customer?.deliveryEmail }}
</ng-template>
<ng-template #opSalespointTemplate let-item="item">
  <span class="medium">{{ item.operation.salespoint?.name || '-' }}</span>
</ng-template>
<ng-template #opSellerTemplate let-item="item">
  <br>{{ item.operation.user?.firstName }} {{ item.operation.user?.lastName }}
</ng-template>

<!-- TICKET DETAILS -->
<router-outlet></router-outlet>
